import { useCallback } from 'react';
import * as scheduleService from '../services/scheduleService';
import {
  IAddScheduleExceptionRequest,
  ICreateScheduleRequest,
  IUpdateScheduleRequest,
} from '../types/interfaces/ISchedule';

export function useSchedules() {
  const getSchedules = useCallback(async (institutionId: string) => {
    return await scheduleService.getSchedules(institutionId);
  }, []);

  const createSchedule = useCallback(async (payload: ICreateScheduleRequest) => {
    return await scheduleService.createSchedule(payload);
  }, []);

  const updateSchedule = useCallback(
    async (id: string, payload: IUpdateScheduleRequest) => {
      return await scheduleService.updateSchedule(id, payload);
    },
    []
  );

  const addScheduleException = useCallback(
    async (scheduleId: string, payload: IAddScheduleExceptionRequest) => {
      return await scheduleService.addScheduleException(scheduleId, payload);
    },
    []
  );

  const getHolidays = useCallback(async (year: number, institutionId?: string) => {
    return await scheduleService.getHolidays(year, institutionId);
  }, []);

  return {
    getSchedules,
    createSchedule,
    updateSchedule,
    addScheduleException,
    getHolidays,
  };
}